export default __webpack_public_path__ + "static/media/Sell-crypto.a4c11d2a.png";